import { LANGUAGES } from './languages'

export const FRAMEWORK_TYPES = [
    {
        name: 'Google Test',
        value: 'googletest',
        languages: [LANGUAGES.CPP.value, LANGUAGES.C.value],
    },
    {
        name: 'Unittest',
        value: 'unittest',
        languages: [LANGUAGES.PYTHON.value, LANGUAGES.PYTHON3.value],
    },
    {
        name: 'JUnit 4',
        value: 'junit4',
        languages: [LANGUAGES.JAVA.value],
    },
    {
        name: 'JUnit 5',
        value: 'junit5',
        languages: [LANGUAGES.JAVA.value],
    },
    {
        name: 'Flexible',
        value: 'flexible',
        languages: [
            LANGUAGES.CPP.value,
            LANGUAGES.CPP.value,
            LANGUAGES.MATLAB.value,
            LANGUAGES.PYTHON.value,
            LANGUAGES.PYTHON3.value,
        ],
    },
    {
        name: 'Advanced SQL(Python)',
        value: 'sql',
        languages: [LANGUAGES.SQL.value],
    },
]

export const getFrameworkName = value => {
    const framework = FRAMEWORK_TYPES.find(framework => framework.value === value)
    return framework ? framework.name : 'Unknown framework'
}
